export default __webpack_public_path__ + "static/media/redwood.bef86570.PNG";